var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortuneWheelOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2998 23.4427C16.2667 23.8038 15.1563 24 14 24C10.345 24 7.14798 22.0391 5.40356 19.112L13.5163 15.3289L17.2998 23.4427ZM19.112 22.5964L15.3289 14.4837L23.4427 10.7002C23.8038 11.7333 24 12.8437 24 14C24 17.655 22.0391 20.852 19.112 22.5964ZM22.5964 8.88804L14.4837 12.6711L10.7002 4.55725C11.7333 4.19625 12.8437 4 14 4C17.655 4 20.852 5.96088 22.5964 8.88804ZM8.88804 5.40356C5.96088 7.14798 4 10.345 4 14C4 15.1563 4.19625 16.2667 4.55725 17.2998L12.6711 13.5163L8.88804 5.40356ZM26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortuneWheelOutline);
export default __webpack_public_path__ + "static/media/fortune_wheel_outline.37a3a3b6fbb6122fb0b207e6497542ec.svg";
export { ForwardRef as ReactComponent };